import { stringifyQs } from "@dashboard/utils/urls";
import urlJoin from "url-join";

import {
  type BulkAction,
  type Dialog,
  type Filters,
  type Pagination,
  type Sort,
  type TabActionDialog,
} from "../types";

export const brandSection = "/brands/";

export const brandListPath = brandSection;
export enum BrandListUrlFiltersEnum {
  query = "query",
}
export type BrandListUrlFilters = Filters<BrandListUrlFiltersEnum>;
export type BrandListUrlDialog = "delete" | TabActionDialog;
export enum BrandListUrlSortField {
  name = "name",
  createdAt = "createdAt",
}
export type BrandListUrlSort = Sort<BrandListUrlSortField>;
export type BrandListUrlQueryParams = BulkAction &
  BrandListUrlFilters &
  BrandListUrlSort &
  Dialog<BrandListUrlDialog> &
  Pagination;
export const brandListUrl = (params?: BrandListUrlQueryParams) =>
  brandListPath + "?" + stringifyQs(params);

export const brandPath = (id: string) => urlJoin(brandSection, id);
export type BrandUrlDialog = "delete";
export type BrandUrlQueryParams = Dialog<BrandUrlDialog>;
export const brandUrl = (id: string, params?: BrandUrlQueryParams) =>
  brandPath(encodeURIComponent(id)) + "?" + stringifyQs(params);

export const brandAddPath = urlJoin(brandSection, "add");
export const brandAddUrl = brandAddPath;
